(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .factory('NationalBrokerageSearch', NationalBrokerageSearch);

    NationalBrokerageSearch.$inject = ['$resource'];

    function NationalBrokerageSearch($resource) {
        var resourceUrl =  'api/_search/national-brokerages/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
